import React from 'react';
import { Form } from 'components';

const DatePickerOptions = ({ disabled }) => (
  <React.Fragment>
    <Form.DatePicker
      name="defaultValue"
      className="create-form-field-v2__options-date"
      label="Default value"
      defaultValue={new Date()}
      disabled={disabled}
    />
  </React.Fragment>
);

export default DatePickerOptions;
